import React from "react";
import { FaTiktok, FaTwitch, FaYoutube } from "react-icons/fa";
import "./SocialLinks.css";

const socials = [
  { href: "https://www.twitch.tv/haloextravalanza", icon: <FaTwitch />,   label: "Twitch" },
  { href: "https://Tiktok.com/yourpage", icon: <FaTiktok/>,  label: "Tiktok" },
  { href: "https://Youtube.com/yourpage", icon: <FaYoutube/>,  label: "Youtube" },
];

export default function SocialLinks() {
  return (
    <div className="social-links">
      {socials.map(({ href, icon, label }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
}
